
import React, { useRef, useState } from 'react';

function Blank(props) {
  const iframeRef = useRef(null);  // Reference to the iframe
  const [iframeHeight, setIframeHeight] = useState(600); // Initial height of iframe

  const handleIframeLoad = () => {
    const iframe = iframeRef.current;
    if (iframe && iframe.contentWindow) {
      // Get the document inside the iframe and calculate its height
      const iframeDocument = iframe.contentWindow.document;
      const iframeBody = iframeDocument.body;
      const height = iframeBody.scrollHeight; // Get the height of the body content
      setIframeHeight(height+60); // Set the height dynamically
    }
  };

  console.log(props.photos);
  

  return (
    <div style={{width:"100%", height:"100%"}}>
      {
        props.photos.map(p => 
        <div style={{width:"100%", height:"100vh"}}><iframe
        className='blankIframe'
        ref={iframeRef}
        src={`${p}`} // This loads the HTML from the public folder
        height={iframeHeight}
        title="HTML Viewer"
        onLoad={handleIframeLoad} // Trigger when iframe content loads
      ></iframe><br/><br/></div>
        )
      }  
      
       
    </div>
  );
}

export default Blank;
